import { formatCurrency } from "../../../utils";

export type StatusVariant = "success" | "failed" | "pending" | "unknown";

export const getStatusVariant = (status?: number): StatusVariant => {
	switch (status) {
		case 2:
			return "success";
		case 3:
			return "failed";
		case 1:
			return "pending";
		default:
			return "unknown";
	}
};

// Mirrors Shared.Domain.Enums.VendingStatus
export const VENDING_STATUS = {
	UNKNOWN: 0,
	IN_PROGRESS: 1,
	COMPLETED: 2,
	FAILED: 3,
	FAILED_WITH_REFUND: 4,
} as const;

export const getVendingStatusVariant = (status?: number): StatusVariant =>
	status === VENDING_STATUS.FAILED_WITH_REFUND ? "failed" : getStatusVariant(status);

export const getStatusLabel = (status?: number): string => {
	switch (status) {
		case 2:
			return "Success";
		case 3:
			return "Failed";
		case 1:
			return "Pending";
		default:
			return "Unknown";
	}
};

export const formatDateTime = (dateTime?: string): string => {
	if (!dateTime) {
		return "-";
	}
	const date = new Date(dateTime);
	if (Number.isNaN(date.getTime())) {
		return "-";
	}

	const day = date.getDate();
	const ordinalSuffix = getOrdinalSuffix(day);
	const month = date.toLocaleString("en-US", { month: "short" });
	const year = date.getFullYear();

	let hours = date.getHours();
	const minutes = date.getMinutes().toString().padStart(2, "0");
	const ampm = hours >= 12 ? "pm" : "am";
	hours = hours % 12;
	hours = hours === 0 ? 12 : hours;

	return `${day}${ordinalSuffix} ${month} ${year}, ${hours}:${minutes}${ampm}`;
};

const getOrdinalSuffix = (day: number): string => {
	const rem10 = day % 10;
	const rem100 = day % 100;

	if (rem10 === 1 && rem100 !== 11) return "st";
	if (rem10 === 2 && rem100 !== 12) return "nd";
	if (rem10 === 3 && rem100 !== 13) return "rd";
	return "th";
};

export const formatMoney = (amount?: { amount: number; currency: string }) => {
	if (!amount) {
		return undefined;
	}
	return formatCurrency(amount.amount, { currency: amount.currency });
};

export const getPaymentMethodLabel = (type?: number) => {
	switch (type) {
		case 1:
			return "Payment Hub";
		case 2:
			return "Cash Payment";
		default:
			return "Unknown";
	}
};
